import React from "react";
import { useSelector } from "react-redux";
import "./style.scss";

const Spinner = () => {
  const { anythingLoading } = useSelector((state) => state.spinner);

  return (
    <>
      {anythingLoading ? (
        <div className="overlay">
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Spinner;
